export default __webpack_public_path__ + "static/media/smoking.09b9a8e3.svg";